import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { EASE } from '../data/site';

const LightboxImage = ({ src, alt, caption, testId, className = '', imgClassName = '' }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid={testId}
        className={`group/lb relative block w-full cursor-zoom-in overflow-hidden ${className}`}
      >
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className={`w-full object-cover transition-transform duration-700 group-hover/lb:scale-[1.03] ${imgClassName}`}
        />
        <span className="absolute bottom-3 right-3 bg-brand-black/85 text-paper text-[10px] font-semibold uppercase tracking-[0.25em] px-3 py-2 opacity-0 transition-opacity duration-300 group-hover/lb:opacity-100">
          Tap to expand
        </span>
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-[110] flex items-center justify-center bg-brand-black/95 p-5 md:p-16 cursor-zoom-out"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35 }}
            onClick={() => setOpen(false)}
            data-testid="lightbox-overlay"
          >
            <button
              data-testid="lightbox-close"
              aria-label="Close"
              className="absolute top-5 right-5 z-10 text-paper/70 transition-colors duration-300 hover:text-paper"
              onClick={() => setOpen(false)}
            >
              <X size={30} />
            </button>
            <motion.img
              src={src}
              alt={alt}
              initial={{ scale: 0.88, y: 30 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.92, opacity: 0 }}
              transition={{ duration: 0.5, ease: EASE }}
              className="max-h-[82vh] max-w-full object-contain shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
            {caption && (
              <p className="absolute bottom-5 left-0 right-0 px-6 text-center text-paper/60 text-[11px] uppercase tracking-[0.3em]">
                {caption}
              </p>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default LightboxImage;
